import { html } from 'fxjs/es';
import { reviewHeaderTmpl } from './reviewHeaderTmpl.js';
import { reviewListTmpl } from './reviewListTmpl.js';
import { OMPCoreLayoutTmplS } from '../../../Core/Layout/S/Tmpl/module/OMPCoreLayoutTmplS.js';

export const reviewTmpl = ({
  is_mobile,
  is_best,
  reviews,
  review_total,
  cate_lists,
  query,
  sub_menus,
  is_detail_page, // revieTmpl 을 사용하는 페이지가 상세페이지인지 여부 (상세페이지는 디자인이 살짝 다름)
}) => {
  return html`
    ${sub_menus ? OMPCoreLayoutTmplS.bodySubMenu(sub_menus) : ''}
    <div class="omp-review">
      ${reviewHeaderTmpl({ is_mobile, cate_lists, query, is_best, review_total, is_detail_page })}
      ${reviewListTmpl({
        is_mobile,
        reviews,
        review_total,
        query,
        is_detail_page,
      })}
    </div>
  `;
};
